{
  "en": {
    "overview": {
      "actions": {
        "select_decision": "Select decision",
        "select_installment": "Select installment",
        "select_point_list": "Select snagging list",
        "select_survey": "Select survey"
      },
      "table": {
        "labels": {
          "category": "Category",
          "level": "Level",
          "project": "Project",
          "status": "Status"
        }
      }
    }
  }
}
